var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['app-gradient-cell', { inverted: (_vm.numberValue / _vm.max >= 0.80), max: _vm.isMax }],style:({ background: _vm.colorCode })},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }